import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PolicyStore from '../../../stores/Policy/PolicyStore';
import { FTBody } from '../../Fuse';
import FuseAlert from '../../FuseControls/FuseAlert';
import FuseCheckbox from '../../FuseControls/FuseCheckbox';
import PolicyModal from '../PolicyModal';
import AccessCodeInfo from './AccessCodeInfo';
import { ROLE_READ_ONLY } from '../../../stores/Administrators/AdministratorModalStore';
import ConsoleStore from '../../../stores/ConsoleStore';

class AccessCodesModal extends Component {
    static propTypes = {
        console: ConsoleStore.PropType,
        policy: PolicyStore.PropType.isRequired,
    };

    confirmDeleteMessage = (flagStore) => {
        return <FuseAlert
            type="danger"
            title="Delete Confirmation"
            style={{ marginBottom: '20px', minWidth: '320px' }}
        >
            <FTBody>
                Access codes cannot be restored once deleted. All browsers activated with this code will be reverted
                back to the default browsing role.
            </FTBody>
            <FuseCheckbox
                black
                store={flagStore}
                label={'Confirm the deletion of this access code'}
                qa={'confirm-delete'}
            />
        </FuseAlert>;
    }

    render() {
        const { console, policy } = this.props;
        const { policyModal } = policy.accessCodes.policyTable;

        return <PolicyModal
            titleItemName="Access Code"
            itemName="Code"
            store={policyModal}
            readOnly={console.authority === ROLE_READ_ONLY.value}
            confirmDeleteMessage={this.confirmDeleteMessage}
        >
            <AccessCodeInfo store={policyModal.sections.info} mode={policyModal.mode}/>
        </PolicyModal>;
    }
}

export default inject('console', 'policy')(observer(AccessCodesModal));
